import { IRecipientProfileHeaderInfo } from "@nkr/models/recipients/profile/header-info";
import { Label, Well } from "react-bootstrap";

type TProps = {
    headerInfo: IRecipientProfileHeaderInfo
}

export default function SubHeader({ headerInfo }: TProps) {

    return (
        <Well bsSize='sm' style={{ marginBottom: 0, borderTop: '0 none', borderLeft: '0 none', borderRight: '0 none' }}>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <div style={{ display: 'flex', alignItems: 'center', marginRight: 10 }}>
                    <div style={{ paddingRight: 10 }}>Patient Type:</div>
                    <div>
                        <Label style={{ fontSize: '100%' }}>{headerInfo.patientType}</Label>
                    </div>
                </div>

                <div style={{ display: 'flex', alignItems: 'center', marginRight: 10 }}>
                    <div style={{ paddingRight: 10 }}>Registration Date:</div>
                    <div>
                        <Label style={{ fontSize: '100%' }}>{headerInfo.dateRegistered}</Label>
                    </div>
                </div>

                {headerInfo.firstExportableDate.length > 0 && (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div style={{ paddingRight: 10 }}>First Exportable On:</div>
                        <div>
                            <Label style={{ fontSize: '100%' }}>{headerInfo.firstExportableDate}</Label>
                        </div>
                    </div>
                )}
            </div>
        </Well>
    );
}
